import { render, staticRenderFns } from "./Comedian.vue?vue&type=template&id=70a735fb&scoped=true"
var script = {}
import style0 from "./Comedian.vue?vue&type=style&index=0&id=70a735fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a735fb",
  null
  
)

export default component.exports